var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { EXPANDER_LEFT, EXPANDER_RIGHT } from './types';
export const ExpanderRow = (_a) => {
    var { colSpan, isExpanded, expandableRowComponent: CustomComponent, expanderPosition, id, className } = _a, props = __rest(_a, ["colSpan", "isExpanded", "expandableRowComponent", "expanderPosition", "id", "className"]);
    return (React.createElement("tr", { className: cn('cb-table-expandable-row', !isExpanded && 'hidden', className), "aria-hidden": !isExpanded, id: id },
        React.createElement("td", { className: cn('cb-table-expandable-container', expanderPosition === EXPANDER_LEFT && 'cb-table-expandable-trigger-left', expanderPosition === EXPANDER_RIGHT && 'cb-table-expandable-trigger-right'), colSpan: colSpan }, isExpanded && CustomComponent && React.createElement(CustomComponent, Object.assign({}, props)))));
};
//# sourceMappingURL=ExpanderRow.js.map